/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Infragraph Service
 * APIs for managing Infragraph.
 *
 * The version of the OpenAPI document: 2025-05-07
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HashicorpCloudInfragraph20250507ConfigFromJSON, HashicorpCloudInfragraph20250507ConfigToJSON, } from './HashicorpCloudInfragraph20250507Config';
import { HashicorpCloudInfragraph20250507SourceFromJSON, HashicorpCloudInfragraph20250507SourceToJSON, } from './HashicorpCloudInfragraph20250507Source';
/**
 * Check if a given object implements the HashicorpCloudInfragraph20250507UpsertConnectionBody interface.
 */
export function instanceOfHashicorpCloudInfragraph20250507UpsertConnectionBody(value) {
    return true;
}
export function HashicorpCloudInfragraph20250507UpsertConnectionBodyFromJSON(json) {
    return HashicorpCloudInfragraph20250507UpsertConnectionBodyFromJSONTyped(json, false);
}
export function HashicorpCloudInfragraph20250507UpsertConnectionBodyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'source': json['source'] == null ? undefined : HashicorpCloudInfragraph20250507SourceFromJSON(json['source']),
        'config': json['config'] == null ? undefined : HashicorpCloudInfragraph20250507ConfigFromJSON(json['config']),
    };
}
export function HashicorpCloudInfragraph20250507UpsertConnectionBodyToJSON(json) {
    return HashicorpCloudInfragraph20250507UpsertConnectionBodyToJSONTyped(json, false);
}
export function HashicorpCloudInfragraph20250507UpsertConnectionBodyToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'source': HashicorpCloudInfragraph20250507SourceToJSON(value['source']),
        'config': HashicorpCloudInfragraph20250507ConfigToJSON(value['config']),
    };
}
